<script setup>
import {computed, defineAsyncComponent, onMounted} from 'vue';
import { useI18n } from 'vue-i18n';;
import { useRoute } from 'vue-router';
/***/
import { useApplicationStore } from '@stores/application';

// Composants
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Default'));

// Route
const route = useRoute();

// I18n
const { t } = useI18n();

// Stores
const applicationStore = useApplicationStore();

// Application
const currentApplication = computed(() => applicationStore.getCurrent);

// Statut
const statusCodeParam = route.params.statusCode || '404';
const allowedStatusCodes = [ '401', '403', '404', '500', '503' ];
const statusCode = (allowedStatusCodes.indexOf(statusCodeParam) !== -1) ? statusCodeParam : '404';

// Classes
const pageClasses = (() => {
   const classes = [ 'page-error' ];
   const statusClass = 'page-error-' + statusCode;
   classes.push(statusClass);
   return classes;
});

// Titre
const pageTitle = (() => t('errors.' + statusCode + '.title'));

onMounted(() => {
    document.title = pageTitle() + ' - ' + currentApplication.value.name;
});

</script>

<template>
    <layout>
        <div :class="pageClasses()">
            <figure class="error">
                <img src="/images/errors/404.webp" alt="" loading="lazy" />
            </figure>

            <h1>{{ $t('errors.default.title') }}</h1>

            <h2>{{ $t('errors.default.subtitle') }}</h2>

            <p class="description">
                {{ $t('errors.default.description') }}
            </p>

            <div class="button-groups footer-button-group button-groups-centered">
                <router-link
                    :to="{ name: 'home' }"
                    title=""
                    class="button button-primary-outline button-small"
                >
                    <span>{{ $t('errors.default.button.home.label') }}</span>
                </router-link>

                <a
                    class="button button-primary button-small"
                    href="mailto:contact@tookano.app"
                    title=""
                >
                    <span>{{ $t('errors.default.button.contact.label') }}</span>
                </a>
            </div>
        </div>
    </layout>
</template>
